module.exports = __webpack_public_path__ + "img/SZ.bb49a013.svg";